// extracted by mini-css-extract-plugin
export default {"container":"login_container__NeSld","wrapper":"login_wrapper__GbQjK","dot":"login_dot__4aYrz","animate":"login_animate__xPYsC"};